module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-sit-4902979103feea11652617bf1583438a.png";